<template>
	<div class="about-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="detailsBox">
			<div class="title">
				岱屿画境AI创作平台用户服务协议
				<div class="time">
					发布日期：2025-12-31 <span>生效日期：2025-12-31</span>
				</div>
			</div>
			<div class="mainTitle f_w_700">岱屿画境平台用户注册协议</div>
			<div class="subTitle d_f_a_c f_w_700">
				生效日期：
				<div class="f_w_400">[2025年12月31日]</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				更新日期：
				<div class="f_w_400">[2025年12月31日]</div>
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				欢迎您（以下简称“创作者”或“您”或“用户”）注册并使用由[杭州岱屿画境科技有限公司]（以下简称“平台”或“我们”）运营的“【岱屿画境】”（以下简称“平台”）提供的服务！
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				请您在注册成为本平台用户或购买作品前，仔细阅读并充分理解本协议的全部内容，特别是其中免除或限制平台责任的条款、知识产权条款、争议解决条款等。当您点击“同意”或类似按钮，或实际使用平台服务（如浏览、购买作品）时，即表示您已阅读、理解并同意接受本协议及相关平台规则的全部内容约束。如您不同意本协议的任何内容，请立即停止注册或使用平台服务。
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				您对本协议的同意或实际使用平台服务的行为，即表示您已充分阅读、理解并接受本协议的全部内容，并与平台达成协议，承诺接受本协议各项条款的约束。
				<span class="f_w_400">如果您不同意本协议的任何内容，或者无法准确理解本协议条款的含义，请立即停止注册或使用平台服务。</span>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第一条 协议主体与定位
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">平台定位：【岱屿画境】</span>平台是为AI生成图片（以下简称“图片”）提供展示、交易、沟通及相关服务的网络信息中介平台。
				平台作为运营方本身不直接参与图片创作，也不对创作者上传图片的创作过程进行直接控制。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">用户定位：</span>“用户”或“您”是指通过平台完成注册程序，并使用平台服务的个人或组织。本协议主要适用于作为作品购买方的用户。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.本协议是您与平台运营方之间就使用平台服务所订立的合法协议。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第二条 平台服务内容
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">平台性质：</span>平台是为AI生成图片（以下简称“作品”）提供展示、交易、撮合服务的网络信息中介平台。
				平台本身不直接创作或销售作品，不对创作者上传作品的内容、质量、合法性及权利归属作任何实质性保证或担保。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">服务内容：</span>2．平台为您提供作品浏览、搜索、购买、支付、有限度的售后支持等服务。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第三条 用户注册与账户
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">用户资格</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				只有符合下列条件之一的自然人或法人才能申请成为本网站用户，可以使用本网站的服务：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 年满十八岁，并具有民事权利能力和完全民事行为能力的自然人。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 限制民事行为能力人应经过其监护人的同意；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 如您不符合以上条件但使用本平台，您与本平台之间的协议自始无效，一经发现，本平台有权立即终止对您的服务；
				如行为已造成本平台损失或第三方损失的，应由您承担赔偿责任，本平台保留追究法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				（认证）用户需要提供明确的联系电话，并提供真实姓名或组织名称。
			</div>
			<div class="subTitle t-indent f_w_400">
				本网站用户须承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">注册要求</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您承诺在注册时提供真实、准确、完整、有效的身份信息、联系方式、支付账户信息等，并保持该等信息的及时更新。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您理解并同意，平台有权根据相关法律法规及政策要求，采取必要的技术和管理措施（如实名认证）对用户身份进行核验。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 用户在本网站注册的账号名称或账号下行为，不得有下列情形：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 违反宪法或法律法规规定的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 损害国家荣誉和利益的，损害公共利益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 煽动民族仇恨、民族歧视，破坏民族团结的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 破坏国家宗教政策，宣扬邪教和封建迷信的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 散布谣言，扰乱社会秩序，破坏社会稳定的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 侮辱或者诽谤他人，侵害他人合法权益的；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 含有法律、行政法规禁止的其他内容的。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您应妥善保管您的账户信息（包括用户名、密码等）及与账户相关的权限凭证。因您保管不善导致账户被盗用或任何其他损失，由您自行承担全部责任。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> 您不得将账户转让、出借或分享给他人使用。您对账户下的一切行为承担法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">账户安全：</span>如发现任何未经授权使用您账户或存在其他安全漏洞的情况，您应立即通知平台。平台有权根据您的请求或自行判断，采取暂停服务、冻结账户等措施。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第四条 作品购买与授权
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">授权模式:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您在平台上购买的作品，其具体的授权范围、使用限制等完全由创作者在发布作品时选择的售卖模式决定。
				您必须在购买前仔细阅读并理解所选作品的授权条款。平台的售卖模式包括但不限于：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> <span class="f_w_700">个人欣赏使用许可（非独占）：</span>
				您获得非独占性的使用许可，仅限于个人欣赏、收藏或非商业性使用，不得用于任何商业目的。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> <span class="f_w_700">个人独家欣赏使用许可（独占）：</span>
				您获得独占性的使用许可，但仅限于非商业性使用。创作者不得再授权他人，但您同样不得将作品用于商业目的。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> <span class="f_w_700">有范围的商业许可：</span>
				您获得在特定范围、品类、时间及数量内的非独占性商业使用许可。具体范围以作品详情页描述为准。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span> <span class="f_w_700">完全买断许可：</span>
				您获得该作品完整的、排他的著作权及相关知识产权。作品将下架，创作者不得再行销售。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">理解授权:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您充分理解并同意，您对作品的使用权利严格限于您所购买的授权模式范围内。
				任何超范围使用（如将个人欣赏许可用于商业用途）均构成违约或侵权，您将自行承担全部法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">权利冲突:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				平台通过技术手段尽力避免权利冲突，但因创作者提供虚假信息或违规操作导致您购买的作品存在权利瑕疵或与第三方权利冲突的，
				平台不承担连带责任，但为您向创作者追责提供必要的帮助。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第五条 费用与支付
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">交易价格:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				作品价格由创作者设定，平台展示的价格为含税价。您应按照平台提示的支付方式完成支付。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">服务费:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				平台可能就每笔交易向创作者收取服务费，该费用已由创作者承担，不影响您支付的交易对价。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">支付安全:</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您应通过平台指定的官方支付渠道完成支付。任何线下交易或非官方渠道支付的风险由您自行承担。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第六条 用户的权利与义务
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">用户注册与账户管理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得以虚假信息骗取账号注册，账号名称、头像、简介等资料不得存在违法和不良信息。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得冒用关联机构或社会名人注册账号名称。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户不得以任何形式擅自转让或授权他人使用本平台账户。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户应妥善保管账户信息，并对账户下的所有行为承担法律责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">尊重知识产权</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您应尊重创作者的知识产权，仅在获得的授权范围内使用作品。禁止复制、修改、分发、公开展示或利用作品从事任何未经明确授权的行为。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">禁止不正当行为</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您不得从事任何干扰、破坏平台正常运营秩序的行为，包括但不限于：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				利用技术手段恶意爬取数据；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				发布虚假信息或恶意评价；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				从事套现、洗钱等违法支付行为；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				诋毁、诽谤平台或其他用户。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span class="f_w_700">禁止私下交易（禁止跳单）</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				您理解并同意，所有与作品相关的沟通、议价、交易及支付均应在平台内完成。
				您不得在平台内或通过任何其他渠道，引导、提议或与创作者进行任何形式的私下交易，以规避平台交易规则及应支付的服务费用。这包括但不限于：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				引导创作者至其他平台（如微信、QQ）、网站或线下进行交易；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				索取或提供非平台指定的联系方式、支付账号等以进行线下交易；
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				与创作者达成任何旨在规避平台服务费的协议或安排。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span class="f_w_700">内容合法性</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				如果您在平台社区或沟通中发布任何内容，您需保证其合法性，不包含违法、淫秽、暴力、欺诈或侵犯他人权益的信息。
			</div>
			<div class="subTitle t-indent f_w_400">
				6.<span class="f_w_700">纠纷处理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户在交易过程中如与其他用户产生纠纷，可请求平台协助调解。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				用户发现其他用户有违法或违反本协议的行为，可向平台举报。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第七条 平台的权利与义务
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">服务保障</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有义务在现有技术条件下确保平台正常运行，尽力避免服务中断。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台应及时回复用户在注册和使用过程中遇到的问题和反馈。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">管理权限</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权对用户注册资料进行审查，对存在问题的资料有权要求用户解释或改正。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				如发生以下情形，平台有权限制用户活动、要求核实资料、发出警告或中止服务：
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 用户违反本协议或相关规则；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span> 收到第三方投诉且无法联系到用户核证；
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="square"></span>明显存在违法或不当行为可能造成损害的情况。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权依据协议冻结、处置违规用户账户内的资金。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">内容管理</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权删除或限制以下信息：规避费用为目的；炒作信用为目的；存在欺诈或虚假内容；与交易无关；扰乱交易秩序；违反公共利益等。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权将用户公开作品及相关信息用于平台宣传推广（包括但不限于社交媒体、合作媒体、线下活动等），但应标明作者信息。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第八条 免责声明
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">平台性质：平台仅作为网络服务提供者和交易组织者，</span>1．不对创作者上传的图片内容（包括其合法性、真实性、准确性、完整性、有效性）负责，
				也不对创作者与买家之间的交易行为（除平台提供的支付托管服务外）负责。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span
					class="f_w_700">作品“按现状”提供：</span>平台无法对海量作品进行逐一实质性审查。您理解并同意，平台不对作品的真实性、准确性、完整性、有效性、合法性及是否侵犯第三方权利作任何明示或默示的担保。
				因使用作品产生的任何纠纷、损失，您应直接与创作者协商解决，平台可提供必要的协助。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span
					class="f_w_700">平台定位：【岱屿画境】</span>平台服务依其现状提供。平台尽力维护服务的稳定性与安全性，但对服务的中断、延迟、错误、数据丢失等不作担保，也不承担由此给您造成的损失（除非该损失由平台的故意或重大过失直接造成）。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span
					class="f_w_700">第三方风险：</span>您理解并同意，与买家的沟通、交易存在一定风险（如欺诈、违约），您应自行判断并承担该等风险。平台对买家行为的合法性、履约能力等不作任何担保。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span
					class="f_w_700">AI生成风险：</span>您理解AI生成图片的特性，平台对图片的质量、风格、是否符合预期、是否存在潜在伦理或法律风险（如深度伪造风险）等不作任何保证。您应自行评估并承担使用AI工具生成及销售图片的相关风险。
			</div>
			<div class="subTitle t-indent f_w_400">
				6.<span class="f_w_700">不可抗力：</span>因不可抗力（如自然灾害、政府行为、黑客攻击、电信故障等）导致平台无法提供服务或履行义务的，平台不承担责任。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第九条 违规处理
			</div>
			<div class="subTitle t-indent f_w_400">
				1．如您违反本协议的任何条款，或违反平台发布的其他规则、公告，平台有权根据违规行为的性质、情节严重程度及造成的后果，独立判断并采取以下一项或多项措施：
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">警告：</span>通过站内信、邮件等方式提醒您纠正违规行为。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">限制功能：</span>限制您账户的部分功能（如禁止发布评论、禁止与创作者沟通）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">账户冻结：</span>暂时冻结您的账户，冻结期间您将无法登录和使用平台服务。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">账户封禁：</span>永久关闭您的账户，终止向您提供服务，并清退账户内余额（如涉及违法所得，平台有权不予退还或依法处置）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				<span class="f_w_700">追究责任：</span>平台保留向有关主管部门报告、移交司法机关处理以及依法追究您法律责任的权利。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．平台对违规行为的认定和处理享有最终决定权。您同意平台行使该等权利的结果。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十条 保密
			</div>
			<div class="subTitle t-indent f_w_400">
				用户保证在使用本网站过程中所获悉的属于【岱屿画境】及他方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。
				未经该资料和文件的原提供方同意，用户不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十一条 协议修改与终止
			</div>
			<div class="subTitle t-indent f_w_400">
				1．<span
					class="f_w_700">协议修改：</span>平台有权根据法律法规变化、业务调整、技术发展等原因，随时修改本协议。修改后的协议将在平台公布后生效。如您不同意修改后的协议，您有权停止使用平台服务。
				如您在修改生效后继续使用平台服务，则视为您接受修改后的协议。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．<span class="f_w_700">协议终止：</span>
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				您有权随时通过注销账户的方式终止本协议（需符合平台注销流程）。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				平台有权根据本协议第就条（违规处理）的规定终止向您提供服务。
			</div>
			<div class="subTitle f_w_400">
				<span class="point"></span>
				无论因何种原因终止，本协议第九条（违规处理）、第十条（法律适用与争议解决）等条款仍继续有效。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十二条 法律适用与争议解决
			</div>
			<div class="subTitle t-indent f_w_400">
				1．法律适用：本协议的订立、效力、解释、履行和争议解决均适用中华人民共和国大陆地区法律（不包括冲突法）。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．争议解决：因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交至上海市普陀区人民法院管辖。
				败诉方应承担胜诉方全部的维权费用包括诉讼费用、聘请律师费用、公证费用等。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第十三条 其他
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">通知：</span>平台向您发出的通知，可通过平台公告、站内信、电子邮件、短信等方式进行。该等通知于发送之日视为已送达。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">可分割性：</span>如果本协议的任何条款被认定为无效或不可执行，该条款应被修改以达到其预期目的，且不影响其他条款的效力。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span
					class="f_w_700">完整协议：</span>本协议构成您与平台就本协议所涉事项达成的完整协议，取代任何先前的口头或书面约定。本协议与本平台公示的各项规则组成，相关名词可互相引用参照，如有不同理解，以本协议条款为准。
			</div>
			<div class="subTitle t-indent f_w_400">
				4.<span class="f_w_700">协议更新：</span>平台有权根据需要修改本协议。修改后会通过网站公告等方式通知您。若您继续使用平台服务，即视为接受修改后的协议。
			</div>
			<div class="subTitle t-indent f_w_400">
				5.<span class="f_w_700">标题：</span>本协议各条款的标题仅为方便阅读而设，不影响条款本身的含义或解释。
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				再次提醒：在点击“同意”或开始使用平台服务前，请务必仔细阅读并理解本协议的全部内容。您的注册或使用行为即表示您同意接受本协议的约束。
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				[杭州岱屿画境科技有限公司]
			</div>
			<div class="agreeContent subTitle t-indent f_w_700">
				[日期：2025年12月31日]
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AgreementPage',
		mounted() {
			console.log('关于我们页面已加载')
		}
	}
</script>

<style lang="scss" scoped>
	.about-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.detailsBox {
		margin: .6rem auto 1.2rem;
		padding-bottom: .32rem;
		width: 12rem;
		border-radius: .12rem;
		background: #FFFFFF;
		overflow: hidden;
		z-index: 1;

		.title {
			height: .9rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .8rem;
			font-weight: 500;
			font-size: .24rem;
			color: #4C4943;
			background: #CDBB98;
		}

		.time {
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #333333;

			span {
				margin-left: .12rem;
			}
		}

		.msgContent {
			padding: .4rem .8rem .8rem;
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
		}
	}

	.mainTitle {
		margin-top: .12rem;
		text-align: center;
	}

	.subTitle {
		margin-top: .12rem;
		padding: 0 .2rem;
	}

	.t-indent {
		text-indent: 2em;
	}

	.d_f_a_c {
		display: flex;
		align-items: center;
	}

	.f_w_700 {
		font-weight: 700;
	}

	.f_w_400 {
		font-weight: 400;
	}

	.point {

		&::before {
			display: inline-block;
			margin-right: 4px;
			content: '';
			width: 10px;
			height: 10px;
			background: #252525;
			border-radius: 50%;
		}
	}

	.square {

		&::before {
			display: inline-block;
			margin-right: 4px;
			content: '';
			width: 10px;
			height: 10px;
			background: #252525;
			border-radius: 2px;
		}
	}
</style>